 document.addEventListener("DOMContentLoaded", function () {
  new Swiper(".custome-swiper", {
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
    slidesPerView: "auto",
    spaceBetween: 20,
    breakpoints: {
      768: {
        slidesPerView: 3,
      },
    },
  });
});